(() => {
  const banner = document.querySelector('[data-funnel-return]');
  if (!banner || !document.referrer) return;
  try {
    const origin = new URL(document.referrer);
    if (origin.origin !== window.location.origin || !/^\/checkouts?(?:\/|$)/.test(origin.pathname)) return;
    const saved = JSON.parse(sessionStorage.getItem('veranelle:funnel-cure') || 'null');
    const age = Date.now() - Number(saved?.checkoutStartedAt);
    if (!saved || !Number.isFinite(age) || age < 0 || age > 30 * 60 * 1000) return;
    const link = [...banner.querySelectorAll('[data-return-variant]')]
      .find(candidate => candidate.dataset.returnVariant === saved.variantId);
    if (!link) return;
    link.hidden = false;
    banner.hidden = false;
  } catch {
    return;
  }
})();
